export default "__VITE_ASSET__Bik9zrYP__"